var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"height":"100%"}},[_c('h1',[_vm._v("Arup Compute Statistics")]),_c('FunctionPopularity')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }